import { WORK_BADGE_REVIEW_POLICY_FULL_PATH } from "../../Documents/paths";
import { type WorkBadgeReviewPolicySource } from "../components/Policy/types";
import { type WorkBadgeReviewPolicyStep } from "../hooks/useWorkBadgeReviewPolicy";

interface GetWorkBadgeReviewPolicyUrlParams {
  source: WorkBadgeReviewPolicySource;
  shiftId: string;
  qualificationName: string;
  step: WorkBadgeReviewPolicyStep;
}

export function getWorkBadgeReviewPolicyUrl(params: GetWorkBadgeReviewPolicyUrlParams): string {
  const { source, shiftId, qualificationName, step } = params;

  const searchParams = new URLSearchParams({
    source,
    shiftId,
    qualificationName,
    step,
  });

  return `${WORK_BADGE_REVIEW_POLICY_FULL_PATH}?${searchParams.toString()}`;
}
